import { useEffect } from "react";

export const usePageMeta = (title) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};